const verbsTypes = {
    ENTER: 'enter',
    EXIT: 'exit',
}

export default verbsTypes;